import { ApiClient } from "./ApiClient";
import { UserAttributes } from "typings";
import qs from "qs";
import { ReactText } from "react";

// TODO: change back to api v2 once released
const currentUserPath = "/api/user";

const usersPath = "/api/v2/users";

const getCurrent = () => ApiClient().get(currentUserPath);

const getById = (
  id: string,
  options?: {
    include?: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma", encode: false });
  return ApiClient().get(`${usersPath}/${id}?${params}`);
};

const getAll = ({
  sort,
  offset,
  limit,
  filter,
  size,
  number,
  include,
}: {
  sort?: string;
  offset?: number;
  limit?: number;
  size?: number;
  number?: number;
  filter?: { [key: string]: string | undefined };
  include?: string[];
} = {}) => {
  const params = qs.stringify(
    {
      sort,
      include,
      page: {
        offset,
        limit,
        size,
        number,
      },
      filter,
    },
    { arrayFormat: "comma" },
  );
  return ApiClient().get(`${usersPath}?${params}`);
};

const create = (payload: {
  data: {
    type: string;
    attributes: UserAttributes;
  };
}) => ApiClient().post(usersPath, payload);

const edit = (
  userId: string,
  attributes: UserAttributes,
  options?: {
    include?: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().patch(`${usersPath}/${userId}?${params}`, {
    data: {
      type: "users",
      id: userId,
      attributes,
    },
  });
};

const getDistributionLists = (
  userId: string,
  options: {
    include?: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma", encode: false });
  return ApiClient().get(`${usersPath}/${userId}/distribution_lists?${params}`);
};

const getCaseFollows = (
  userId: string,
  options: {
    include?: string[];
    filter?: { [key: string]: string | undefined };
    number?: number;
    size?: number;
  },
) => {
  const { number, size, ...rest } = options;
  const params = qs.stringify(
    { ...rest, page: { number, size } },
    { arrayFormat: "comma", encode: false },
  );
  return ApiClient().get(`${usersPath}/${userId}/case_follows?${params}`);
};

const addAssignedStaff = (
  {
    userId,
    supportId,
  }: {
    userId: string;
    supportId: string;
  },
  options?: {
    include?: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().post(`${usersPath}/${userId}/assigned_staff?${params}`, {
    data: {
      attributes: {
        staffId: supportId,
      },
    },
  });
};

const addSupportedAttorneys = (
  {
    userId,
    supportId,
  }: {
    userId: string;
    supportId: string;
  },
  options?: {
    include?: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().post(
    `${usersPath}/${userId}/supported_attorneys?${params}`,
    {
      data: {
        attributes: {
          attorneyId: supportId,
        },
      },
    },
  );
};

const removeAssignedStaff = ({
  userId,
  staffId,
}: {
  userId: string;
  staffId: string | ReactText;
}) => ApiClient().delete(`${usersPath}/${userId}/assigned_staff/${staffId}`);

const removeSupportedAttorneys = ({
  userId,
  attorneyId,
}: {
  userId: string;
  attorneyId: string | ReactText;
}) =>
  ApiClient().delete(
    `${usersPath}/${userId}/supported_attorneys/${attorneyId}`,
  );

const removeUser = ({ userId }: { userId: string }) =>
  ApiClient().delete(`${usersPath}/${userId}`);

const getReport = ({
  sort,
  offset,
  limit,
  filter,
  size,
  number,
  include,
}: {
  sort?: string;
  offset?: number;
  limit?: number;
  size?: number;
  number?: number;
  filter?: { [key: string]: string | undefined };
  include?: string[];
} = {}) => {
  const params = qs.stringify(
    {
      sort,
      include,
      page: {
        offset,
        limit,
        size,
        number,
      },
      filter,
    },
    { arrayFormat: "comma" },
  );
  return ApiClient().get(`${usersPath}/report?${params}`);
};

export default {
  getCurrent,
  getById,
  getAll,
  create,
  edit,
  getDistributionLists,
  getCaseFollows,
  addAssignedStaff,
  addSupportedAttorneys,
  removeAssignedStaff,
  removeSupportedAttorneys,
  removeUser,
  getReport,
};
